import { consumptionAndEmissionsToCaEInput, eecCarlineRangeToCaEInput, createConsumptionAndEmissionDisclaimerFormatter, } from "@oneaudi/audi-cae-formatter";
import { fetchConfigurationByAudiCode } from "../data-sources/casa/casa";
import { fetchCarlineById } from "../data-sources/eec-carline-ranges/carline";
import { fetchEfficiencyDataByPrString } from "../data-sources/tedas/tedas";
import { fetchCaeFormatterTranslations } from "../i18n";
const VueFormatterServiceCreatorV1 = (options) => {
    return {
        create: (consumerId, _dependencies) => {
            return {
                featureService: new VueFormatterServiceV1(consumerId, options, _dependencies),
            };
        },
    };
};
export class VueFormatterServiceV1 {
    consumerId;
    i18nMessages = undefined;
    serviceConfig;
    knucklesI18nUrl;
    webApiUrl;
    locale;
    constructor(consumerId, options, _dependencies) {
        this.serviceConfig = options;
        this.consumerId = consumerId;
        this.knucklesI18nUrl =
            this.serviceConfig.KNUCKLES_I18N_ENDPOINT || "https://knuckles-i18n.web-api.audi.com/cae-formatter";
        this.webApiUrl = this.serviceConfig.VUE_AGW_ENDPOINT || "https://web-api.audi.com";
        this.locale = this.serviceConfig.locale;
    }
    async vueForAudiCode(country, language, audiCode) {
        const [i18nResources, vehicle] = await Promise.all([
            fetchCaeFormatterTranslations({
                baseUrl: this.knucklesI18nUrl,
                country: country,
                language: language,
            }),
            fetchConfigurationByAudiCode({
                webApiBaseUrl: this.webApiUrl,
                country: country,
                language: language,
                code: audiCode,
            }),
        ]);
        const caeData = vehicle?.configurationDetails?.vue;
        if (!i18nResources || !caeData) {
            throw new Error("Failed to load required data for vueForAudiCode");
        }
        const caeFormatterInput = consumptionAndEmissionsToCaEInput(caeData);
        const disclaimers = createConsumptionAndEmissionDisclaimerFormatter({
            country: country,
            language: language,
            i18nResources: i18nResources,
            locale: this.locale,
        }).createDisclaimers(caeFormatterInput);
        return this.createConsumptionAndEmissionWithDisclaimers(caeData, disclaimers);
    }
    async vueForPRString(country, language, prString) {
        const [i18nResources, caeData] = await Promise.all([
            fetchCaeFormatterTranslations({
                baseUrl: this.knucklesI18nUrl,
                country: country,
                language: language,
            }),
            fetchEfficiencyDataByPrString({
                webApiBaseUrl: this.webApiUrl,
                country: country,
                language: language,
                prString: prString,
            }),
        ]);
        if (!i18nResources || !caeData) {
            throw new Error("Failed to load required data for vueForPRString");
        }
        const caeFormatterInput = consumptionAndEmissionsToCaEInput(caeData);
        const disclaimers = createConsumptionAndEmissionDisclaimerFormatter({
            country: country,
            language: language,
            i18nResources: i18nResources,
            locale: this.locale,
        }).createDisclaimers(caeFormatterInput);
        return this.createConsumptionAndEmissionWithDisclaimers(caeData, disclaimers);
    }
    async vueForRawData(country, language, rawData) {
        const i18nResources = await fetchCaeFormatterTranslations({
            baseUrl: this.knucklesI18nUrl,
            country: country,
            language: language,
        });
        if (!i18nResources) {
            throw new Error("Failed to load required data for vueForRawData");
        }
        const caeFormatterInput = consumptionAndEmissionsToCaEInput(rawData);
        const disclaimers = createConsumptionAndEmissionDisclaimerFormatter({
            country: country,
            language: language,
            i18nResources: i18nResources,
            locale: this.locale,
        }).createDisclaimers(caeFormatterInput);
        return this.createConsumptionAndEmissionWithDisclaimers(rawData, disclaimers);
    }
    async vueForCarline(country, language, carlineId) {
        const [i18nResources, carline] = await Promise.all([
            fetchCaeFormatterTranslations({
                baseUrl: this.knucklesI18nUrl,
                country: country,
                language: language,
            }),
            fetchCarlineById({
                webApiBaseUrl: this.webApiUrl,
                country: country,
                language: language,
                carlineId: carlineId,
            }),
        ]);
        if (!i18nResources || !carline) {
            throw new Error("Failed to load required data for vueRangeForCarline");
        }
        const caeFormatterInput = eecCarlineRangeToCaEInput(carline);
        const caeFormatter = createConsumptionAndEmissionDisclaimerFormatter({
            country: country,
            language: language,
            i18nResources: i18nResources,
            locale: this.locale,
        });
        if (caeFormatterInput.type === "PREFORMATTED") {
            return caeFormatter.createDisclaimersFromPreformatted(caeFormatterInput.data);
        }
        return caeFormatter.createDisclaimers(caeFormatterInput.data);
    }
    async vueRangeForCarline(country, language, carlineId) {
        return this.vueForCarline(country, language, carlineId);
    }
    createConsumptionAndEmissionWithDisclaimers(caeData, disclaimers) {
        return {
            ...caeData,
            formattedConsumption: disclaimers.formattedConsumption,
            formattedDischargedConsumption: disclaimers.formattedDischargedConsumption,
            formattedEmission: disclaimers.formattedEmission,
            formattedCo2Class: disclaimers.formattedCo2Class,
            formattedDischargedCo2Class: disclaimers.formattedDischargedCo2Class,
            footnote: disclaimers.footnote,
        };
    }
}
export { VueFormatterServiceCreatorV1, };
//# sourceMappingURL=vue-formatter-feature-service.js.map